import { render, staticRenderFns } from "./petBeautiful.vue?vue&type=template&id=0a1f22da&scoped=true&"
import script from "./petBeautiful.vue?vue&type=script&lang=js&"
export * from "./petBeautiful.vue?vue&type=script&lang=js&"
import style0 from "./petBeautiful.vue?vue&type=style&index=0&id=0a1f22da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1f22da",
  null
  
)

export default component.exports